<template>
  <div class="ui two columns grid" style="padding-top: 20px;"> 
    <div class="row">
      <div class="column">
        <h4 class="ui dividing header">
          {{ $t('patientInfo') }}
        </h4>
        <abstractTable
          :data="patientInfo"
          :definitionTable="true"
          :definitionTableWidth="'16%'"
          :classes="'ui compact definition table'"
        >
        </abstractTable>
      </div>
      <div class="column">
        <h4 class="ui dividing header">
          {{ $t('reservationInfo') }}
        </h4>
        <abstractTable
          :data="reservationInfo"
          :definitionTable="true"
          :definitionTableWidth="'30%'"
          :classes="'ui compact definition table'"
        >
        </abstractTable>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    reservation: { type: Object, reqired: true },
  },
  computed: {
    patientInfo() {
      return {
        [this.$t('name')]: this.$auth.check('doctor')
          ? {
              html: true,
              functionality: () => {
                this.navigateTo('Show_Patient', {
                  key: 'params',
                  value: { id: this.reservation.patient.id }
                });
              },
              value: `<a style="cursor: pointer;">${this.adjustName(this.reservation.patient.name)}</a>`
            }
          : this.adjustName(this.reservation.patient.name),
        [this.$t('mobile')]: this.$auth.check('employee') || this.isAdmin() ?
           this.reservation.patient.cell_phone : '-',
        [this.$t('age')]: this.reservation.patient.date_of_birth ?
          this.getAge(this.reservation.patient.date_of_birth) : '-'
      };
    },
    reservationInfo() {
      return {
        [this.$t('issuedBy')]: this.reservation.user.name,
        total_price: this.formatPrice(Number(this.reservationTotalPrice)),
        total_paid: Number(this.reservationTotalPaid) < Number(this.reservationTotalPrice) ?
          {
            html: true,
            functionality: () => { },
            value: `<span style="color: red;">${this.formatPrice(Number(this.reservationTotalPaid))}</span>`
          }
          :
          this.formatPrice(Number(this.reservationTotalPaid)),
        note: {
          html: true,
          value: `<span style="white-space: pre-line;">${this.reservation.note || '-'}</span>`
        }
      };
    },
    reservationTotalPrice() {
      return window._.sumBy(this.reservation.reservations_packages, reservationPackage => {
        const currentPackage = reservationPackage.package
        const packagePrice = Number(currentPackage.unit_price) * Number(currentPackage.quantity)
        return Number(reservationPackage.repeated) * packagePrice
      });
    },
    reservationTotalPaid() {
      return window._.sumBy(this.reservation.transactions, transaction => {
        return Number(transaction.amount)
      })
    } 
  },
  methods: {
    getIssuerType(reservation) {
      return reservation.user.profile_type === 'employee'
        ? 'Employee'
        : 'Doctor';
    },
    getPriceForVisitPackage(visitDetail) {
      let selectedPackage = window._.find(
        this.reservation.packages,
        selectedPackageEntity => {
          return selectedPackageEntity.id === visitDetail.package_id;
        }
      );
      
      let unitPrice = Number(selectedPackage.unit_price);
      return Number(visitDetail.quantity) * unitPrice;
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/reservations/reservation_components/ReservationInfo.vue